import { loanInfoConstants , userConstants } from "../_constants";
const loanInfoInitialState = { accountViews: null, accountViewsLoaded: false, loanViews: [], loanViewsLoaded: false, numberOfReferralsEarned: 0, leads: [], leadsLoaded: false, lastLead: null, hasActiveLeads: false };
const loanInfoInvalidateState = { loanViewsLoaded: false }

export function  loanInfo(state = loanInfoInitialState, action) 
{
    switch(action.type){
        case loanInfoConstants.GET_USER_LOAN_VIEWS:
            return { ...state };
            
        case loanInfoConstants.USER_ACCOUNT_HISTORY:
            return { ...state };

        case loanInfoConstants.TOGGLE_ACTIVITY_VIEW: 
        case loanInfoConstants.TOGGLE_PAYMENT_SCHEDULED_VIEW:
        case loanInfoConstants.LOAD_ACCOUNT_ACTIVITY_SUCCESS:
            return {...state, loanViews: state.loanViews.map(view => 
                view.currentLoanId === action.loanView.currentLoanId ? action.loanView : view
                ), loanViewsLoaded: true, numberOfReferralsEarned: state.numberOfReferralsEarned};
        
        case loanInfoConstants.LOAD_USER_LOAN_VIEWS_SUCCESS:
            action.accountViews.loanAccountViews.map(view => {
                view.accountActivity = [];
                view.scheduledPayments = [];
                view.detailsLoaded = false; 
                view.showPaymentSchedule = false; 
                view.showAccountActivity = false; 
            })
        
            return { ...state, lastLead: state.lastLead, accountViews: action.accountViews, accountViewsLoaded:true, numberOfReferralsEarned: state.numberOfReferralsEarned};
        case loanInfoConstants.NUMBER_REFERRALS_EARNED_LOADED: 
            sessionStorage.setItem('referrals', action.numberOfReferralsEarned);
            return {...state, lastLead: state.lastLead, loanViews: state.loanViews, loanViewsLoaded: state.loanViewsLoaded, numberOfReferralsEarned : action.numberOfReferralsEarned}
            
        case loanInfoConstants.LEADS_LOADED:
            return { ...state, leads: action.leads, leadsLoaded: true }; 
        //case loanInfoConstants.BANNER_DATA_LOADED:
        //    var banner = JSON.parse(action.bannerData);
        //    return { ...state, bannerData: action.bannerData, showBanner: banner.showBanner, englishBanner: banner.english, spanishBanner: banner.spanish };

        case loanInfoConstants.LAST_LEAD_LOADED: 
            return {...state, lastLead : action.lastLead};
        case userConstants.LOGOUT:
            return loanInfoInitialState;
        case userConstants.INVALIDATE_LOANS_STATE:
            return loanInfoInvalidateState;
        
        default: 
            return state; 
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/loanInfo.reducer.js